import React from 'react'
import {Global} from '@emotion/react'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const Fonts = () => (
    <Global
        styles={`
    @font-face {
      font-family: 'GTEesti';
      src: url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Light.woff')}') format('woff'),
         url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Light.svg')}#GTEesti Light') format('svg');
      font-weight: 300;
      font-style: normal;
    }
    @font-face {
      font-family: 'GTEesti';
      src: url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Regular.woff')}') format('woff'),
         url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Regular.svg')}#GTEesti Regular') format('svg');
      font-weight: 400;
      font-style: normal;
    }
    @font-face {
      font-family: 'GTEesti';
      src: url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Medium.woff')}') format('woff'),
         url('${getAssetUrl('./static/fonts/GTEesti/GTEestiProDisplay-Medium.svg')}#GTEesti Medium') format('svg');
      font-weight: 500;
      font-style: normal;
    }
    @font-face {
      font-family: 'GTEesti';
      src: url('${getAssetUrl('./static/fonts/GTEesti/GTEestiDisplay-Bold.woff')}') format('woff'),
         url('${getAssetUrl('./static/fonts/GTEesti/GTEestiDisplay-Bold.svg')}#GTEesti Bold') format('svg');
      font-weight: 600;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-Light.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-Light.woff')}') format('woff');
      font-weight: 300;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-LightItalic.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-LightItalic.woff')}') format('woff');
      font-weight: 300;
      font-style: italic;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-Medium.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-Medium.woff')}') format('woff');
      font-weight: 400;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-MediumItalic.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-MediumItalic.woff')}') format('woff');
      font-weight: 400;
      font-style: italic;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-Semibold.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-Semibold.woff')}') format('woff');
      font-weight: 500;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-SemiboldItalic.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-SemiboldItalic.woff')}') format('woff');
      font-weight: 500;
      font-style: italic;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-Bold.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-Bold.woff')}') format('woff');
      font-weight: 600;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-BoldItalic.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-BoldItalic.woff')}') format('woff');
      font-weight: 600;
      font-style: italic;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-Black.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-Black.woff')}') format('woff');
      font-weight: 700;
      font-style: normal;
    }
    @font-face {
      font-family: 'Quarto';
      src: url('${getAssetUrl('./static/fonts/Quarto/Quarto-BlackItalic.woff2')}') format('woff2'),
         url('${getAssetUrl('./static/fonts/Quarto/Quarto-BlackItalic.woff')}') format('woff');
      font-weight: 700;
      font-style: italic;
    }
    `}
    />
)

export default Fonts
